import api from "../api/axios";

export const getLoanTypes = async (groupId) => {
  const response = await api.get(`/loan-type/${groupId}`);
  return response.data;
};

export const getLoanType = async (id) => {
  const response = await api.get(`/loan-type/single/${id}`);
  return response.data;
};

export const createLoanType = async (payload) => {
  const response = await api.post(`/loan-type/`, payload);
  return response.data;
};

export const updateLoanType = async (payload) => {
  const response = await api.put(`/loan-type/${payload.id}`, payload);
  return response.data;
};
